<template>
  <div>
    <div class="box">
      <p class="heading">Users</p>
      <div class="container">
        <ul>
          <li>
            Total:
            <span class="has-text-weight-bold">
              {{ globalStats.totalUsers }}
            </span>
          </li>
          <li>
            No Recordings:
            <span class="has-text-weight-bold">
              {{ globalStats.usersWithoutRecordings }}
            </span>
          </li>
          <li>
            With recordings:
            <span class="has-text-weight-bold">
              {{ globalStats.usersWithRecordings }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="box">
      <p class="heading">Recordings</p>
      <div class="container">
        <ul>
          <li>
            Total:
            <span class="has-text-weight-bold">
              {{ globalStats.recordingsCount }}
            </span>
          </li>
          <li>
            Anonymous:
            <span class="has-text-weight-bold">
              {{ globalStats.anonymousRecordingsCount }}
            </span>
          </li>
          <li>
            Named:
            <span class="has-text-weight-bold">
              {{ globalStats.userRecordingsCount }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["globalStats"]
};
</script>

<style lang="scss" scoped></style>
